import { Suspense, useState, lazy } from "react";
import "./App.css";
import { IntlProvider } from "react-intl";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SharedLayout from "./pages/SharedLayout";
import { useSelector } from "react-redux";
import Loading from "./pages/Loading";
import NotFound from "./pages/NotFound";
import SuspenseFallback from "./components/SuspenseFallback";
import ComingSoon from "./components/ComingSoon";
import Verify from "./pages/Verify";

const Home = lazy(() => import("./pages/Home"));
const Location = lazy(() => import("./pages/Location"));
const Util = lazy(() => import("./pages/Util"));
const Subdivision = lazy(() => import("./pages/Subdivision"));
const Gallery = lazy(() => import("./pages/Gallery"));

const LayoutWisteria = lazy(() => import("./pages/wisteria/LayoutWisteria"));
const HomeWisteria = lazy(() => import("./pages/wisteria/HomeWisteria"));
const EbrochureWisteria = lazy(() => import("./pages/wisteria/EbrochureWisteria"));
const GroundWisteria = lazy(() => import("./pages/wisteria/GroundWisteria"));
const HouseWisteria = lazy(() => import("./pages/wisteria/HouseWisteria"));
const UtilWisteria = lazy(() => import("./pages/wisteria/UtilWisteria"));

const LayoutFlameVine = lazy(() => import("./pages/flamevine/LayoutFlameVine"));
const HomeFlameVine = lazy(() => import("./pages/flamevine/HomeFlameVine"));
const EbrochureFlameVine = lazy(() => import("./pages/flamevine/EbrochureFlameVine"));
const GroundFlameVine = lazy(() => import("./pages/flamevine/GroundFlameVine"));
// const HouseFlameVine = lazy(() => import("./pages/flamevine/HouseWisteria"));
const UtilFlameVine = lazy(() => import("./pages/flamevine/UtilFlameVine"));
const GalleryFlameVine = lazy(() => import("./pages/flamevine/GalleryFlameVine"));
const LocationFlameVine = lazy(() => import("./pages/flamevine/LocationFlameVine"));

const LayoutBinhMinh = lazy(() => import("./pages/binhminh/LayoutBinhMinh"));
const HomeBinhMinh = lazy(() => import("./pages/binhminh/HomeBinhMinh"));
const GroundBinhMinh = lazy(() => import("./pages/binhminh/GroundBinhMinh"));
const UtilBinhMinh = lazy(() => import("./pages/binhminh/UtilBinhMinh"));
const HouseBinhMinh = lazy(() => import("./pages/binhminh/HouseBinhMinh"));
const EbrochureBinhMinh = lazy(() => import("./pages/binhminh/EbrochureBinhMinh"));

const LayoutThaoVien = lazy(() => import("./pages/thaovien/LayoutThaoVien"));
const HomeThaoVien = lazy(() => import("./pages/thaovien/HomeThaoVien"));
const GroundThaoVien = lazy(() => import("./pages/thaovien/GroundThaoVien"));
const UtilThaoVien = lazy(() => import("./pages/thaovien/UtilThaoVien"));
const HouseThaoVien = lazy(() => import("./pages/thaovien/HouseThaoVien"));
const EbrochureThaoVien = lazy(() => import("./pages/thaovien/EbrochureThaoVien"));

const LayoutThinhVuong = lazy(() => import("./pages/thinhvuong/LayoutThinhVuong"));
const HomeThinhVuong = lazy(() => import("./pages/thinhvuong/HomeThinhVuong"));
const GroundThinhVuong = lazy(() => import("./pages/thinhvuong/GroundThinhVuong"));
const UtilThinhVuong = lazy(() => import("./pages/thinhvuong/UtilThinhVuong"));
const HouseThinhVuong = lazy(() => import("./pages/thinhvuong/HouseThinhVuong"));
const EbrochureThinhVuong = lazy(() => import("./pages/thinhvuong/EbrochureThinhVuong"));

function App() {
  const { messages, locale } = useSelector((state) => state.language);
  const [checkVerify, setCheckVerify] = useState(true);

  return (
    <IntlProvider messages={messages} locale={locale}>
      <div>
        <Suspense fallback={<SuspenseFallback />}>
          <Router basename={process.env.PUBLIC_URL}>
            {checkVerify === true ? (
              <Routes>
                <Route path="/" index element={<Loading />} />
                {/* <Route index path="/demo" element={<DemoMap />} />  */}
                <Route element={<SharedLayout />}>
                  <Route index path="/tour" element={<Home />} />
                  <Route index path="/locations" element={<Location />} />
                  <Route index path="/utilities" element={<Util />} />
                  <Route index path="/subdivisions" element={<Subdivision />} />
                  <Route index path="/gallery" element={<Gallery />} />
                </Route>

                <Route element={<LayoutFlameVine />}>
                  <Route
                    index
                    path="/the-flame-vine"
                    element={<HomeFlameVine />}
                  />
                  <Route
                    index
                    path="/the-flame-vine/ground"
                    element={<GroundFlameVine />}
                  />
                  <Route
                    index
                    path="/the-flame-vine/ground/:building"
                    element={<GroundFlameVine />}
                  />
                  <Route
                    index
                    path="/the-flame-vine/utilities"
                    element={<UtilFlameVine />}
                  />
                  {/* <Route
                    index
                    path="/the-flame-vine/houses"
                    element={<ComingSoon />}
                  /> */}
                  <Route
                    index
                    path="/the-flame-vine/locations"
                    element={<LocationFlameVine />}
                  />
                  <Route
                    index
                    path="/the-flame-vine/gallery"
                    element={<GalleryFlameVine />}
                  />
                  <Route
                    index
                    path="/the-flame-vine/ebrochure"
                    element={<EbrochureFlameVine />}
                  />
                </Route>

                <Route element={<LayoutWisteria />}>
                  <Route
                    index
                    path="/the-wisteria"
                    element={<HomeWisteria />}
                  />
                  <Route
                    index
                    path="/the-wisteria/ground"
                    element={<GroundWisteria />}
                  />
                  <Route
                    index
                    path="/the-wisteria/utilities"
                    element={<UtilWisteria />}
                  />
                  <Route
                    index
                    path="/the-wisteria/houses"
                    element={<HouseWisteria />}
                  />
                  <Route
                    index
                    path="/the-wisteria/ebrochure"
                    element={<EbrochureWisteria />}
                  />
                </Route>

                <Route element={<LayoutBinhMinh />}>
                  <Route index path="/binh-minh" element={<HomeBinhMinh />} />
                  <Route
                    index
                    path="/binh-minh/ground"
                    element={<GroundBinhMinh />}
                  />
                  <Route
                    index
                    path="/binh-minh/utilities"
                    element={<UtilBinhMinh />}
                  />
                  <Route
                    index
                    path="/binh-minh/houses"
                    element={<HouseBinhMinh />}
                  />
                  <Route
                    index
                    path="/binh-minh/ebrochure"
                    element={<EbrochureBinhMinh />}
                  />
                </Route>

                <Route element={<LayoutThaoVien />}>
                  <Route index path="/thao-vien" element={<HomeThaoVien />} />
                  <Route
                    index
                    path="/thao-vien/ground"
                    element={<GroundThaoVien />}
                  />
                  <Route
                    index
                    path="/thao-vien/utilities"
                    element={<UtilThaoVien />}
                  />
                  <Route
                    index
                    path="/thao-vien/houses"
                    element={<HouseThaoVien />}
                  />
                  <Route
                    index
                    path="/thao-vien/ebrochure"
                    element={<EbrochureThaoVien />}
                  />
                </Route>

                <Route element={<LayoutThinhVuong />}>
                  <Route
                    index
                    path="/thinh-vuong"
                    element={<HomeThinhVuong />}
                  />
                  <Route
                    index
                    path="/thinh-vuong/ground"
                    element={<GroundThinhVuong />}
                  />
                  <Route
                    index
                    path="/thinh-vuong/utilities"
                    element={<UtilThinhVuong />}
                  />
                  <Route
                    index
                    path="/thinh-vuong/houses"
                    element={<HouseThinhVuong />}
                  />
                  <Route
                    index
                    path="/thinh-vuong/ebrochure"
                    element={<EbrochureThinhVuong />}
                  />
                </Route>

                <Route path="*" element={<NotFound />} />
              </Routes>
            ) : (
              <Routes>
                <Route
                  path="/*"
                  element={<Verify setCheckVerify={setCheckVerify} />}
                />
              </Routes>
            )}
          </Router>
        </Suspense>
      </div>
    </IntlProvider>
  );
}

export default App;
